module.exports = __webpack_public_path__ + "img/icon_chevron_left.8810b4ee.svg";